(() => {
  'use strict';
  const data = document.getElementById('gs-canvas-visual-pilot-data');
  if (!data || window.gsCanvasVisualPilot) return;
  window.gsCanvasVisualPilot = true;
  const config = JSON.parse(data.textContent);
  const assetBase = new URL('.', document.currentScript.src).href;
  const locale = (document.documentElement.lang || window.Shopify?.locale || 'fr').split('-')[0].toLowerCase();
  const copy = ({
    fr: {finish:'Finition', size:'Dimensions en centimètres', alt:' — aperçu de la toile', canvasCaption:'Toile livrée roulée - chassis non inclus', canvasDisclosure:'Toile livrée roulée · châssis non inclus', kit:'À assembler en quelques minutes · rendu galerie'},
    en: {finish:'Finish', size:'Dimensions in centimetres', alt:' — canvas preview', canvasCaption:'Canvas delivered rolled - stretcher not included', canvasDisclosure:'Canvas delivered rolled · stretcher not included', kit:'Assemble in minutes · gallery finish'},
    de: {finish:'Ausführung', size:'Abmessungen in Zentimetern', alt:' — Leinwandvorschau', canvasCaption:'Leinwand gerollt geliefert - Keilrahmen nicht enthalten', canvasDisclosure:'Leinwand gerollt geliefert · Keilrahmen nicht enthalten', kit:'In wenigen Minuten montiert · Galerie-Look'},
    es: {finish:'Acabado', size:'Dimensiones en centímetros', alt:' — vista previa del lienzo', canvasCaption:'Lienzo entregado enrollado - bastidor no incluido', canvasDisclosure:'Lienzo entregado enrollado · bastidor no incluido', kit:'Se monta en pocos minutos · acabado de galería'},
    nl: {finish:'Afwerking', size:'Afmetingen in centimeters', alt:' — voorbeeld van het canvas', canvasCaption:'Canvas wordt opgerold geleverd - spanraam niet inbegrepen', canvasDisclosure:'Canvas wordt opgerold geleverd · spanraam niet inbegrepen', kit:'In enkele minuten te monteren · galerielook'}
  })[locale] || {finish:'Finish', size:'Dimensions in centimetres', alt:' — canvas preview', canvasCaption:'Canvas delivered rolled - stretcher not included', canvasDisclosure:'Canvas delivered rolled · stretcher not included', kit:'Assemble in minutes · gallery finish'};
  const finishLabel = (variants, value, fallback) => {
    const mapped = window.GSFinishOptionLabel?.(variants, 1, value, fallback);
    if (mapped && mapped !== fallback) return mapped;
    const normalized = String(value || fallback || '').toLowerCase();
    if (/toile seule|canvas only|solo lienzo|lienzo solo|nur leinwand|alleen canvas/.test(normalized)) return window.GSFinishLabels.canvas;
    if (/châssis|chassis|kit|stretcher|frame|bastidor|keilrahmen|spieraam/.test(normalized)) return window.GSFinishLabels.kit;
    return mapped || fallback;
  };
  function finishTransition(stage) {
    let target, surface;
    const apply = finish => {
      if (finish === target) return;
      const initial = target === undefined;
      target = finish;
      stage.dataset.finish = finish;
      surface?.setFinish(finish, initial);
    };
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(e => e.isIntersecting)) return;
      observer.disconnect();
      import(assetBase + 'gs-pdp-assembly.js?v=no-wood-reveal-1').then(m => m.createSurface(stage, config, assetBase))
        .then(value => { surface = value; surface.setFinish(target, true); })
        .catch(() => { stage.dataset.renderer = 'image-fallback'; });
    }, {rootMargin:'200px'});
    observer.observe(stage);
    return apply;
  }
  // Native selects remain in their original DOM order and own commerce.
  function segmentedChoices(root) {
    root.querySelectorAll('select[data-variant-input]').forEach(select => {
      const index = select.dataset.index;
      if (index !== 'option1' && index !== 'option2') return;
      const wrapper = select.closest('.variant-wrapper');
      if (!wrapper) return;
      const isFinish = index === 'option1';
      let group = wrapper.querySelector('.gs-cvp-choices');
      if (!group) {
        group = document.createElement('div');
        group.className = 'gs-cvp-choices ' + (isFinish ? 'gs-cvp-finishes' : 'gs-cvp-sizes');
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', isFinish ? copy.finish : copy.size);
        for (const option of select.options) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'gs-cvp-choice';
          button.dataset.value = option.value;
          if (isFinish) {
            const sheet = option.value === 'toile seule';
            button.innerHTML = '<svg viewBox="0 0 28 28" aria-hidden="true" focusable="false"><path d="' + (sheet ? 'M6 3h16v20H9l-4 2 1-5V3Zm3 20v-4l-3 1' : 'M5 6 19 3l5 4v17l-5 1L5 21V6Zm0 0 14 3 5-2M19 9v16') + '"/></svg>';
            button.append(document.createTextNode(finishLabel(config.variants, option.value, option.textContent)));
          } else {
            button.textContent = option.value.replace(/\s/g, '').replace(/x/gi, '×').replace(/cm$/i, ' cm');
          }
          button.addEventListener('click', () => {
            if (select.value === button.dataset.value) return;
            select.value = button.dataset.value;
            select.dispatchEvent(new Event('input', {bubbles:true}));
            select.dispatchEvent(new Event('change', {bubbles:true}));
            schedule();
          });
          group.append(button);
        }
        group.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          const buttons = [...group.querySelectorAll('button:not(:disabled)')];
          const current = buttons.indexOf(document.activeElement);
          if (current < 0) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus();
          buttons[next].click();
        });
        select.after(group);
        wrapper.classList.add('gs-cvp-choice-wrapper');
        wrapper.parentElement.classList.add('gs-cvp-picker');
        select.hidden = true;
      }
      for (const button of group.children) {
        const selected = button.dataset.value === select.value;
        button.setAttribute('aria-pressed', String(selected));
        const paired = root.querySelector('select[data-variant-input][data-index="' + (isFinish ? 'option2' : 'option1') + '"]');
        const available = config.variants.some(v => v[index] === button.dataset.value && (!paired || v[paired.dataset.index] === paired.value) && v.available);
        button.disabled = select.disabled || !available;
      }
    });
  }
  function init() {
    const root = document.getElementById('shopify-section-' + config.sectionId);
    if (!root) return;
    const slide = root.querySelector('.product-main-slide[data-index="0"]');
    const form = root.querySelector('form.product-single__form');
    const variantInput = form?.querySelector('[name="id"]');
    const atc = form?.querySelector('[data-add-to-cart]');
    if (!slide || !variantInput || !atc) return;
    root.classList.add('gs-cvp-scope');
    let stage = slide.querySelector('.gs-cvp-stage');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'gs-cvp-stage';
      stage.innerHTML = '<div class="gs-cvp-shadow"><div class="gs-cvp-object"><img class="gs-cvp-face" alt="" width="1006" height="1280"><span class="gs-cvp-right" aria-hidden="true"></span><span class="gs-cvp-top" aria-hidden="true"></span></div></div><span class="gs-cvp-caption"></span>';
      stage.querySelector('.gs-cvp-object').style.aspectRatio = config.faceWidth + '/' + config.faceHeight;
      stage.querySelector('img').alt = (config.artTitle || document.title) + copy.alt;
      stage.querySelector('img').width = config.faceWidth;
      stage.querySelector('img').height = config.faceHeight;
      stage.style.setProperty('--wrap-right', 'url("' + config.wrapRight + '")');
      stage.style.setProperty('--wrap-top', 'url("' + config.wrapTop + '")');
      stage.querySelector('img').crossOrigin = 'anonymous';
      stage.querySelector('img').src = config.art;
      const zoomImage = slide.querySelector('.photoswipe__image');
      if (zoomImage) {
        zoomImage.dataset.photoswipeSrc = config.zoomArt || config.art;
        zoomImage.dataset.photoswipeWidth = String(config.faceWidth);
        zoomImage.dataset.photoswipeHeight = String(config.faceHeight);
      }
      stage.setVisualFinish = finishTransition(stage);
      stage.querySelector('img').addEventListener('load', () => slide.classList.add('gs-cvp-slide'), {once:true});
      slide.append(stage);
    }
    let disclosure = form.querySelector('.gs-cvp-disclosure');
    if (!disclosure) {
      disclosure = document.createElement('p');
      disclosure.className = 'gs-cvp-disclosure';
      disclosure.setAttribute('aria-live','polite');
      atc.before(disclosure);
    }
    const finish = root.querySelector('select[data-variant-input][data-index="option1"]');
    if (finish) {
      const label = root.querySelector('label[for="'+finish.id+'"]');
      if (label && label.textContent.trim() !== copy.finish) label.textContent = copy.finish;
      for (const option of finish.options) {
        const text = finishLabel(config.variants, option.value, option.textContent);
        if (option.textContent !== text) option.textContent = text;
      }
    }
    segmentedChoices(root);
    const variant = config.variants.find(v => String(v.id) === variantInput.value);
    if (!variant) return;
    const kit = variant.option1 !== 'toile seule';
    const key = String(variant.id);
    if (stage.dataset.variant === key) return;
    stage.dataset.variant = key;
    stage.setVisualFinish(kit ? 'kit' : 'canvas');
    stage.querySelector('.gs-cvp-caption').textContent = kit ? copy.kit : copy.canvasCaption;
    disclosure.textContent = kit ? copy.kit : copy.canvasDisclosure;
  }
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; init(); }); };
  document.addEventListener('change', schedule);
  document.addEventListener('variant:change', schedule);
  window.addEventListener('popstate', schedule);
  new MutationObserver(schedule).observe(document.getElementById('shopify-section-' + config.sectionId) || document.body, {childList:true,subtree:true});
  init();
})();
